import React from "react";

export default function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 border-b pb-6" data-testid="page-header">
      <div>
        {eyebrow && <div className="text-[11px] font-mono uppercase tracking-widest text-accent mb-2">// {eyebrow}</div>}
        <h1 className="font-heading font-bold text-3xl md:text-4xl tracking-tight">{title}</h1>
        {description && <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
